/**
 * DYLAN embed endpoints (apps/api routes/dylan.ts — gated `dylan-assistant`).
 *   GET /api/dylan/status → { ok, data: { enabled, url } }
 *   GET /api/dylan/token  → { ok, data: { token, expiresAt, url } }
 * The client returns the envelope; unwrap `data` here.
 */
import { apiGet } from '../client.js';

/** @returns {Promise<{ enabled: boolean, url: string }>} */
export async function fetchDylanStatus() {
  const envelope = await apiGet('/api/dylan/status');
  return envelope?.data ?? envelope;
}

/** @returns {Promise<{ token: string, expiresAt: number, url: string }>} */
export async function fetchDylanToken() {
  const envelope = await apiGet('/api/dylan/token');
  return envelope?.data ?? envelope;
}
